import React from 'react';
import * as Styled from './MStarGroup.styles';
import type { MStarGroupProps } from './MStarGroup.types';

const COMPONENT_NAME = 'm-web-ui-kit-MStarGroup';
const TEST_ID = 'web-ui-kit-MStarGroup';

export const MStarGroup: React.FC<MStarGroupProps> = ({ rating = 0, className, ...rest }) => {
  const totalStars = 5;
  const filledStars = Math.min(Math.max(0, Math.floor(rating)), totalStars);

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      {...rest}
    >
      {Array.from({ length: totalStars }, (_, index) => (
        <Styled.Star key={index} $filled={index < filledStars} aria-hidden="true">
          ★
        </Styled.Star>
      ))}
      <Styled.ScreenReaderText>
        {rating} out of {totalStars} stars
      </Styled.ScreenReaderText>
    </Styled.Wrapper>
  );
};